export default "__VITE_ASSET__DDo_C5TG__"